export default __webpack_public_path__ + "static/media/notification-sound.b3bc44c8.mp3";